import {
    Component,
    ElementRef,
    Input,
    OnInit,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';
import { animationFrameScheduler, fromEvent } from 'rxjs';
import { auditTime, tap } from 'rxjs/operators';

import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../../../common/take-until-destroy.decorator';
import { ViewItem } from '../dialog/model/view-item.model';

/* TODO move to uikit */
@Component({
    selector: 'cmps-uikit-virtual-scroll',
    template: `<div [style.height.px]="_totalHeight"></div>`,
    host: {
        class: 'cmps-cdk-d-block cmps-cdk-pos-relative cmps-cdk-overflow-x-hidden cmps-cdk-overflow-y-auto',
    },
})
@TakeUntilDestroy()
export class VirtualScrollComponent implements OnInit {
    @Input() templateRef: TemplateRef<any>;

    @Input()
    offset: number;

    @Input()
    buffer: number;

    @Input()
    itemHeight: number;

    @Input()
    set items(value: ViewItem[]) {
        this._items = value;
        this._render();
    }

    get items(): ViewItem[] {
        return this._items;
    }

    /** @private */
    _items: ViewItem[];

    /** @private */
    _itemsVisible: ViewItem[];

    _container: HTMLElement;
    _totalHeight: number;

    constructor(
        private readonly _el: ElementRef<HTMLElement>,
        private readonly _vcr: ViewContainerRef,
    ) {
        this.buffer = 10;
    }

    ngOnInit(): void {
        this._bindScroll();
    }

    private _bindScroll(): void {
        fromEvent(this._el.nativeElement.parentElement, 'scroll')
            .pipe(
                auditTime(150, animationFrameScheduler),
                tap(() => {
                    this._render();
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    private _render(): void {
        this._vcr.clear();

        this._container = this._el.nativeElement.parentElement;

        this._totalHeight = this.offset + this.itemHeight * this._items.length;
        const viewport = this._container.getBoundingClientRect().height;
        const scrollTop = this._container.scrollTop;
        const startIdx = Math.max(
            0,
            Math.floor(scrollTop / this.itemHeight) - this.buffer,
        );
        const endIdx = Math.min(
            this._items.length,
            Math.ceil((scrollTop + viewport) / this.itemHeight) + this.buffer,
        );

        this._itemsVisible = this._items.slice(startIdx, endIdx);

        const view = this._vcr.createEmbeddedView(this.templateRef, {
            items: this._itemsVisible,
        });

        const rootNode = view.rootNodes[0] as HTMLElement;
        rootNode.style.position = 'absolute';
        rootNode.style.top = `${this.offset + this.itemHeight * startIdx}px`;
    }
}
